"use client";

import React from "react";
import { useAuth } from "../auth/SessionWrapper";

export default function SignOutButton() {
  const { logout } = useAuth();

  return (
    <button
      type="button"
      className="text-c-text hover:text-c-primary font-bold cursor-pointer"
      onClick={logout}
    >
      Sair
    </button>
  );
}
